















































import {
  Component,
  Prop,
  Vue,
  Watch,
  Mixins,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { specialChannel } from "@root/lib/mixins";
import extendCascader from "@/components/pages/ProductCreate/extendCascader.vue";
import channelAttrBrand from "@/components/pages/ProductCreate/channelComponents/channelAttrBrand.vue";
import { isEqual } from "element-ui/src/utils/util";
import { sleep } from "@root/lib/utils";
const productCreate = namespace("productCreate");
@Component({ components: { extendCascader, channelAttrBrand } })
export default class channelCategory extends Mixins(specialChannel) {
  @InjectReactive("curChannel") curChannel;
  @InjectReactive("curCategory") curCategory;
  @InjectReactive("curBrandId") curBrandId;
  @productCreate.Action queryConnCategoryList;
  @Prop({ default: () => [] }) selectedValue;
  @Prop({ default: false }) disabled;
  @Watch("curCategory", { immediate: true })
  watchSelectedValue(val) {
    console.log("curCategory", val);

    if (val) {
      if (val.join("") !== this.category.join("")) {
        this.category = [...val];
        this.categoryKey = new Date().getTime();
      }
    }
  }
  @Watch("curBrandId", { immediate: true })
  watchCurBrandId(val) {
    console.log("curBrandId", val);

    if (val) {
      this.brandId = val;
      this.brandKey = new Date().getTime();
    }
  }
  categoryText = "";
  category = [];
  categoryKey = new Date().getTime();
  brandId = "";
  brandKey = new Date().getTime();
  selectBrandLabel = "";
  async categoryLazyLoad(node, resolve) {
    const { level } = node;
    let result = [];
    if (!this.curChannel || !this.curChannel.channelCode) {
      return;
    }
    if (node.level === 0) {
      let res = await this.queryConnCategoryList({
        input: {
          channelCode: this.curChannel.channelCode,
          shopCode: this.curChannel.value
        }
      });
      result = res;
    } else {
      if (node.data.children && node.data.children.length) {
        result = node.data.children;
      } else {
        let res = await this.queryConnCategoryList({
          input: {
            channelCode: this.curChannel.channelCode,
            shopCode: this.curChannel.value,
            categoryId: node.data.categoryId
          }
        });
        result = res;
      }
    }
    return resolve(result);
  }
  selectCategory(data) {
    if (!isEqual(data.value, this.category)) {
      let info: any = this.$t("20200917.Product.page_refresh");
      let confirmButtonText: any = this.$t("20200917.Product.switch");
      let cancelButtonText: any = this.$t("Basic.Cancel");
      this.$confirm(info, {
        confirmButtonText,
        cancelButtonText,
        type: "warning"
      })
        .then(() => {
          this.category = [...data.value];
          (this.$refs.categoryCascader as any).setPresentText();
          this.$emit("switchCategory", this.category);
        })
        .catch(() => {
          // this.visible = false;
        });
    } else {
      (this.$refs.categoryCascader as any).closePop();
    }
  }
  async changeSelectBrand(result) {
    await sleep(300);
    let { ref, isSelectChange } = result;
    this.selectBrandLabel = ref.selectedLabel;
    if (isSelectChange) {
      this.$emit("switchBrand", this.brandId);
    }
  }
}
